import React from 'react'
import { useState } from 'react';
import { Card } from 'react-bootstrap'
import { FaMapMarkerAlt, FaPhoneAlt } from 'react-icons/fa'
import MapViewModal from './mapViewModal';

const BranchCard = (props) => {

    const { branch } = props;
    const [ visibleMap, setVisibleMap ] = useState(false)
    const [ selectedMap, setSelectedMap ] = useState(null)

    // console.log('branch', branch);

    const closeMap = () => {
        setSelectedMap(null);
        setVisibleMap(false);
    }

    const openMap = (mapurl) => {
        setSelectedMap(mapurl);
        setVisibleMap(true);
    }

    return (
        <>
            { (!!visibleMap && !!selectedMap) && <MapViewModal branch={branch} visible={visibleMap} closeModal={closeMap.bind(this)} /> }
            <Card className='branch-card d-flex flex-column'>
                <div className="card-header d-flex align-items-center justify-content-between">
                    <h6 className='branch-name font-weight-bold mb-0'>{branch.name}</h6>
                    <a href="##" className='map-link' onClick={() => openMap(branch.mapUrl)}>ম্যাপ দেখুন <FaMapMarkerAlt className="text-danger" /></a>
                </div>
                <div className="px-4 pt-4 pb-0 flex-grow-1">
                    <div className="address mb-3">
                        <p>{ branch.address }</p>
                    </div>
                </div>
                <div className="px-4 pb-3 pt-2">
                    <ul className="phone pl-0 mb-0 list-nostyle">
                        <li><a className='d-inlin-flex align-items-center text-success' href={`tel:${branch.phone}`}><FaPhoneAlt className='mr-2' /> {branch.phone}</a></li>
                        {
                            !!branch.additionalPhone &&
                            <li><a className='d-inlin-flex align-items-center text-success' href={`tel:${branch.additionalPhone}`}><FaPhoneAlt className='mr-2' /> {branch.additionalPhone}</a></li>
                        }
                    </ul>
                </div>
            </Card>
        </>
    )
}

export default BranchCard